import React from "react";
import AllCampaignsCoworker from "../component/sections/campaigns/coworker/AllCampaigns";
import AddCampaignsBannerSimpleCoworker from "../component/sections/campaigns/coworker/banner/simple/AddCampaign";
import SelectCustomerForAddCampaign from "../component/sections/campaigns/coworker/SelectCustomerForAddCampaign";
import AllTypesCampaignCoworker from "../component/sections/campaigns/coworker/AllTypesCampaigns";
import AllTypesBannerCampaignsCoworker from "../component/sections/campaigns/coworker/banner/AllTypesBannerCampaigns";
import AddGroupSitePublisherContainerCampaignBannerCoworker from "../component/sections/campaigns/coworker/banner/simple/AddGroupSitePublisherContainerCampaignBanner";
import ViewCampaignCoworker from "../component/sections/campaigns/coworker/banner/simple/ViewCampaign";
import middleware from "./middlewares/middleware";

const coworkerCampaignsRoutes = [
  {
    path: "/campaigns/coworker/select-customer",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <SelectCustomerForAddCampaign />,
        "SelectCustomerForAddCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/coworker/all/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCampaignsCoworker />,
        "AllCampaignsCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/coworker/banner/simple/add/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddCampaignsBannerSimpleCoworker />,
        "AddCampaignsBannerSimpleCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/coworker/all-type/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTypesCampaignCoworker />,
        "AllTypesCampaignCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/coworker/all-type-banner/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTypesBannerCampaignsCoworker />,
        "AllTypesBannerCampaignsCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/coworker/banner/simple/add-group-site-publisher/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddGroupSitePublisherContainerCampaignBannerCoworker />,
        "AddGroupSitePublisherContainerCampaignBannerCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/coworker/banner/simple/view/:userID/:campaignID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewCampaignCoworker />,
        "ViewCampaignCoworker"
      );
    },
    exact: true,
  },
];

export default coworkerCampaignsRoutes;
